import AxiosService from '@/api/ApiBase';
import { PttApplication } from '@/composables/usePttApplication';
import { AirMblEntity } from '@/types/air/mbl/air-mbl.entity';
import { RestoreService } from '@/types/service/restore.service';
import { VirtualSearchPayload, VirtualSearchResponse } from '@/types/virtual-search';

const AIR_MASTER_BASE_URL = 'cfs/air/airmbl';
// const AIR_MASTER_BASE_URL = 'http://10.142.0.4:7024/airmbl';

class AirMasterService implements RestoreService {
  virtualSearch(payload: VirtualSearchPayload<AirMblEntity>) {
    return AxiosService.post<VirtualSearchResponse<AirMblEntity>>(
      `${AIR_MASTER_BASE_URL}/search`,
      payload
    );
  }

  restore(id: string) {
    return AxiosService.put<string>(`${AIR_MASTER_BASE_URL}/restore/${id}`);
  }

  get(id: string) {
    return AxiosService.get<AirMblEntity>(`${AIR_MASTER_BASE_URL}/details/${id}`);
  }

  update(data: Partial<AirMblEntity>, id: string) {
    return AxiosService.patch(`${AIR_MASTER_BASE_URL}/update/${id}`, data);
  }

  create(data: any) {
    return AxiosService.post(`${AIR_MASTER_BASE_URL}/create`, data);
  }

  delete(id: string) {
    return AxiosService.delete(`${AIR_MASTER_BASE_URL}/delete/${id}`);
  }

  close(id: string) {
    return AxiosService.put<AirMblEntity>(`${AIR_MASTER_BASE_URL}/close/${id}`);
  }

  clone(mblId: string) {
    return AxiosService.post<{ mblId: string; shipmentNumber: string }>(
      `${AIR_MASTER_BASE_URL}/clone`,
      { mblId }
    );
  }

  getMilestones(id: string) {
    return AxiosService.get(`${AIR_MASTER_BASE_URL}/milestones/${id}`);
  }

  getAmsPttDetailsById(id: string) {
    return AxiosService.get<PttApplication>(`warehouse/ptt/request-details/${id}`);
  }

  validateContainerStatus(mblNumber: string, containerNumber: string, mblId?: string) {
    return AxiosService.get<{ status: boolean }>(
      `${AIR_MASTER_BASE_URL}/validate/containerStatus`,
      {
        params: {
          mblNumber: mblNumber,
          containerNumber: containerNumber,
          mblId: mblId,
        },
      }
    );
  }

  // TODO: CHECK BACKEND IMPLEMENTATION

  validateCloseStatus(id: string) {
    return AxiosService.get<any>(`${AIR_MASTER_BASE_URL}/validate/closeStatus`, {
      params: {
        manifestId: id,
      },
    });
  }

  validateForFinalize(mblId: string) {
    return AxiosService.get<any>(`${AIR_MASTER_BASE_URL}/finalize/validate`, {
      params: { mblId },
    });
  }

  finalize(mblId: string) {
    return AxiosService.put(`${AIR_MASTER_BASE_URL}/finalize`, { mblId });
  }
}

export default new AirMasterService();
